/**
 * BRINUTI — LANDING OLDAL, VISELKEDÉS (2026-10-31, v7)
 *
 * A landing több szekcióból áll (fent / közép / lent + a téma saját termékrácsa és lapozója), ezért
 * minden a teljes dokumentumon dolgozik, a gyökér a [data-bl] elem (a „fent” rész).
 *
 * - HERO-GALÉRIA ([data-bl-gal]): a név-író borítók között lapozni lehet (ujjal/nyilakkal), minden
 *   dia alatt a változat-pöttyök (a téma előre legyártott csíkjainak képkockái). A név-folt háttér- és
 *   betűszínt a változat adja (data-bl-bgs / -fgs). A borító-előnézetre koppintva NAGY ABLAKBAN nyílik
 *   (a dia másolata, a névvel együtt).
 * - A beírt név élőben megjelenik minden borítón (.bl-nev) és a ragadós sávban. A hero és a ragadós
 *   gomb a LÁTOTT naplóra mutat: <termék>?beliv=..&valtozat=..(ha pöttyöt választott)&nev=.. A
 *   termékrács (a téma saját kártyái) linkjei a kattintás pillanatában kapják a paramétereket (a
 *   színpötty a linket közben átírhatja). A terméklap (brinuti-landing-pdp.js, brinuti-szinvalto-pdp.js)
 *   ebből tölti ki az űrlapot.
 * - LAPOK-VÁLASZTÁS: a lapozó (brinuti-lapozo) fülei közül a választott lapok kulcsa (hatarido,
 *   idopont, onismereti, pontracsos, vonalas, sima) átkerül a hero/ragadós gombra és a rács linkjeire.
 * - Nagyító a belív-oldalakhoz (data-bl-lb). RAGADÓS SÁV: csak akkor látszik, ha a hero gombja MÁR
 *   FELJEBB gördült a képernyőnél (az oldal tetején, görgetés előtt ne jelenjen meg).
 * - TELEFONON (<700 px): a hero címe és a rács címe egy sorba kerül (a betűméret csak annyit csökken, amennyi kell),
 *   a hero borítója (--bl-f) a lehető legnagyobb, de a gomb alja még a hajtás (100svh) fölött marad.
 * - Események: landing_name_typed, landing_galeria_lapoz, landing_galeria_potty, landing_lapok_valaszt,
 *   landing_borito_nagyit, landing_pages_open, landing_card_click, landing_cta_click, landing_sticky_click
 *   (Clarity + dataLayer).
 */
(function () {
  'use strict';
  var gy = document.querySelector('[data-bl]');
  if (!gy) return;
  var MINTA = gy.getAttribute('data-bl-minta') || '';
  var BELIV = gy.getAttribute('data-bl-beliv') || '';
  var KULCS = 'bl-nev';
  var nevJelenleg = '';
  var JEGY = '';   /* az egyedi modul (jegyválasztó, L16) választása */

  function ev(nev, extra) {
    try { if (window.clarity) window.clarity('event', nev); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: nev }, extra || {})); } catch (e) {}
  }

  function tisztit(s) {
    return String(s || '').replace(/[\u0000-\u001f<>]/g, '').replace(/\s+/g, ' ').replace(/^\s+/, '').slice(0, 24);
  }
  function szavak(nev) {
    return nev.trim().toUpperCase().split(' ').filter(Boolean);
  }
  function szoveg(fmt, nev) {
    var n = nev.trim().toUpperCase();
    if (fmt === 'naploja') return n + ' NAPLÓJA';
    if (fmt === 'utinaploja') return n + ' ÚTINAPLÓJA';
    if (fmt === 'kezdo') return szavak(nev).map(function (r) { return r.charAt(0); }).join('');
    if (fmt === 'cim') {
      return nev.trim().split(' ').filter(Boolean).map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }).join(' ');
    }
    return n;
  }
  function monogram(nev) {
    return szavak(nev).map(function (r) { return r.charAt(0) + '.'; }).join('');
  }

  /* A halvány vonalas oldalfotók (belív) sötétítése gamma-szűrővel, hogy kicsiben is látszódjanak. */
  if (!document.getElementById('bl-sotet')) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.style.position = 'absolute';
    svg.innerHTML = '<filter id="bl-sotet" color-interpolation-filters="sRGB"><feComponentTransfer>' +
      '<feFuncR type="gamma" amplitude="1" exponent="2.2" offset="0"/>' +
      '<feFuncG type="gamma" amplitude="1" exponent="2.2" offset="0"/>' +
      '<feFuncB type="gamma" amplitude="1" exponent="2.2" offset="0"/>' +
      '</feComponentTransfer></filter>';
    document.body.appendChild(svg);
  }

  /* ---------- név a borítókon ---------- */
  var foltok = [].slice.call(document.querySelectorAll('.bl-nev'));
  function fit(f) {
    var b = f.querySelector('b');
    if (!b) return;
    f.style.setProperty('--fit', '1');
    var max = f.clientWidth * 0.86;
    var w = b.scrollWidth;
    if (w > max && w > 0) f.style.setProperty('--fit', Math.max(0.4, max / w).toFixed(3));
  }
  function rajzol(nev) {
    var mit = nev.trim() ? nev : MINTA;
    foltok.forEach(function (f) {
      var fmt = f.getAttribute('data-bl-fmt');
      var b = f.querySelector('b');
      var m = f.querySelector('.bl-nev__m');
      if (b) b.textContent = szoveg(fmt, mit);
      if (m) m.textContent = monogram(mit);
      fit(f);
    });
  }

  /* ---------- nagyító (belív-oldalak és a hero borító-előnézete) ---------- */
  var lb = null;
  var lbGomb = null;
  function lbZar() {
    if (!lb) return;
    lb.remove();
    lb = null;
    document.documentElement.style.overflow = '';
    if (lbGomb && lbGomb.focus) lbGomb.focus();
    lbGomb = null;
  }
  function lbKeret(cim) {
    lb = document.createElement('div');
    lb.className = 'bl bl-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', cim);
    var zar = document.createElement('button');
    zar.type = 'button';
    zar.className = 'bl-lb__zar';
    zar.setAttribute('aria-label', 'Bezárás');
    zar.textContent = '×';
    lb.appendChild(zar);
    lb.addEventListener('click', lbZar);
    return zar;
  }
  function lbNyit(gomb) {
    lbZar();
    lbGomb = gomb;
    var urlek = [gomb.getAttribute('data-bl-lb'), gomb.getAttribute('data-bl-lb2')].filter(Boolean);
    var cim = gomb.getAttribute('data-bl-cimke') || '';
    var zar = lbKeret(cim);
    var lapok = document.createElement('div');
    lapok.className = 'bl-lb__lapok';
    urlek.forEach(function (u) {
      var im = document.createElement('img');
      im.alt = '';
      im.src = u;
      lapok.appendChild(im);
    });
    var felirat = document.createElement('p');
    felirat.className = 'bl-lb__cim';
    felirat.textContent = cim;
    lb.appendChild(lapok);
    lb.appendChild(felirat);
    document.body.appendChild(lb);
    document.documentElement.style.overflow = 'hidden';
    zar.focus();
    ev('landing_pages_open', { lap: cim });
  }
  /* A hero borító-előnézetének nagy ablaka: a látott dia képkockájának másolata (a névvel együtt),
     a teljes mockup látszik, vágás nélkül. */
  function kepNagyit(kep) {
    lbZar();
    var dia = kep.closest('[data-bl-dia]');
    var cim = (dia && dia.getAttribute('aria-label')) || 'Borító';
    var zar = lbKeret(cim);
    var hely = document.createElement('div');
    hely.className = 'bl-lb__kep';
    var klon = kep.cloneNode(true);
    klon.classList.remove('bl-gal__kep');
    klon.style.overflow = 'hidden';
    hely.appendChild(klon);
    var felirat = document.createElement('p');
    felirat.className = 'bl-lb__cim';
    felirat.textContent = cim;
    lb.appendChild(hely);
    lb.appendChild(felirat);
    document.body.appendChild(lb);
    document.documentElement.style.overflow = 'hidden';
    [].forEach.call(klon.querySelectorAll('.bl-nev'), fit);
    zar.focus();
    ev('landing_borito_nagyit', { termek: dia ? dia.getAttribute('data-bl-termek') : '' });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lbZar(); });

  /* ---------- hero-galéria ---------- */
  var gal = document.querySelector('[data-bl-gal]');
  var sav = gal ? gal.querySelector('[data-bl-gal-sav]') : null;
  var diak = gal ? [].slice.call(gal.querySelectorAll('[data-bl-dia]')) : [];
  var jelek = gal ? [].slice.call(gal.querySelectorAll('[data-bl-jel]')) : [];
  var aktiv = 0;
  var allapot = diak.map(function (d) {
    var valt = [];
    try { valt = JSON.parse(d.getAttribute('data-bl-valt') || '[]'); } catch (e) {}
    return {
      i: Number(d.getAttribute('data-bl-i')) || 0,
      valasztott: false,
      valt: valt,
      bgs: (d.getAttribute('data-bl-bgs') || '').split(','),
      fgs: (d.getAttribute('data-bl-fgs') || '').split(',')
    };
  });

  function diaRajz(n) {
    var d = diak[n], a = allapot[n];
    var kep = d.querySelector('.bl-gal__kep');
    if (kep) kep.style.setProperty('--i', String(a.i));
    var folt = d.querySelector('.bl-nev');
    if (folt) {
      if (a.bgs[a.i]) folt.style.setProperty('--bg', a.bgs[a.i]);
      if (a.fgs[a.i]) folt.style.setProperty('--fg', a.fgs[a.i]);
    }
    [].forEach.call(d.querySelectorAll('[data-bl-potty]'), function (b) {
      b.setAttribute('aria-pressed', Number(b.getAttribute('data-bl-potty')) === a.i ? 'true' : 'false');
    });
  }
  function jelFrissit() {
    jelek.forEach(function (j, n) { j.classList.toggle('is-on', n === aktiv); });
  }
  function menj(n) {
    if (!sav || !diak.length) return;
    n = (n + diak.length) % diak.length;
    sav.scrollTo({ left: n * sav.clientWidth, behavior: 'smooth' });
  }
  if (gal && sav && diak.length) {
    var keres = 0;
    /* A görgetésből számoljuk, melyik dia látszik (időzítő, nem rAF: háttérlapon is fut). */
    sav.addEventListener('scroll', function () {
      if (keres) return;
      keres = setTimeout(function () {
        keres = 0;
        var n = Math.round(sav.scrollLeft / Math.max(1, sav.clientWidth));
        if (diak[n] && n !== aktiv) {
          aktiv = n;
          jelFrissit();
          linkFrissit(nevJelenleg);
          ev('landing_galeria_lapoz', { termek: diak[n].getAttribute('data-bl-termek') });
        }
      }, 70);
    }, { passive: true });
    gal.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-bl-gal-elozo]')) { menj(aktiv - 1); return; }
      if (t.closest('[data-bl-gal-kovetkezo]')) { menj(aktiv + 1); return; }
      var b = t.closest('[data-bl-potty]');
      if (b) {
        var dia = b.closest('[data-bl-dia]');
        var n = diak.indexOf(dia);
        if (n < 0) return;
        allapot[n].i = Number(b.getAttribute('data-bl-potty')) || 0;
        allapot[n].valasztott = true;
        diaRajz(n);
        linkFrissit(nevJelenleg);
        ev('landing_galeria_potty', { termek: dia.getAttribute('data-bl-termek') });
        return;
      }
      var kep = t.closest('.bl-gal__kep');
      if (kep) kepNagyit(kep);
    });
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); menj(aktiv - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); menj(aktiv + 1); }
    });
  }

  /* ---------- hero- és ragadós gomb: a látott naplóra mutat ---------- */
  var linkek = [].slice.call(document.querySelectorAll('[data-bl-link]'));
  var alapLink = linkek.length ? linkek[0].getAttribute('href') : '';
  var kiirok = [].slice.call(document.querySelectorAll('[data-bl-nev-ki]'));
  function ctaHref(n) {
    var u;
    if (diak[aktiv]) {
      var a = allapot[aktiv];
      u = diak[aktiv].getAttribute('data-bl-url') + '?beliv=' + encodeURIComponent(BELIV);
      if (a.valasztott && a.valt[a.i]) u += '&valtozat=' + encodeURIComponent(a.valt[a.i]);
    } else {
      u = alapLink.replace(/beliv=[^&]*/, 'beliv=' + encodeURIComponent(BELIV));
    }
    if (JEGY) u += (u.indexOf('?') < 0 ? '?' : '&') + 'jegy=' + encodeURIComponent(JEGY);
    if (n) u += (u.indexOf('?') < 0 ? '?' : '&') + 'nev=' + encodeURIComponent(n);
    return u;
  }
  function linkFrissit(n) {
    var h = ctaHref(n);
    linkek.forEach(function (a) { a.setAttribute('href', h); });
    kiirok.forEach(function (e) { e.textContent = n ? 'Név: ' + n : e.getAttribute('data-bl-alap'); });
  }

  /* A téma termékrácsa: a kártyalinkek a kattintás/érintés pillanatában kapják a paramétereket. */
  function racsLink(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('.product-grid a[href*="/products/"], results-list a[href*="/products/"]');
    if (!a) return;
    try {
      var u = new URL(a.getAttribute('href'), location.href);
      if (u.pathname.indexOf('/products/') < 0) return;
      if (BELIV) u.searchParams.set('beliv', BELIV);
      if (JEGY) u.searchParams.set('jegy', JEGY); else u.searchParams.delete('jegy');
      if (nevJelenleg) u.searchParams.set('nev', nevJelenleg); else u.searchParams.delete('nev');
      a.setAttribute('href', u.pathname + u.search + u.hash);
    } catch (err) {}
  }
  ['pointerdown', 'touchstart', 'mousedown', 'focusin', 'keydown', 'contextmenu'].forEach(function (n) {
    document.addEventListener(n, racsLink, true);
  });

  /* ---------- lapok-választás a lapozónál ---------- */
  var LAPOK = [
    ['onismereti', /önismereti/i], ['hatarido', /határidő/i], ['idopont', /időpont/i],
    ['pontracsos', /pontrácsos|pontozott/i], ['vonalas', /vonalas/i], ['sima', /^\s*(üres|sima)/i]
  ];
  document.addEventListener('click', function (e) {
    var t = e.target;
    var b = t && t.closest ? t.closest('[data-lapozo-valto]') : null;
    if (!b) return;
    var szov = b.textContent || '';
    for (var i = 0; i < LAPOK.length; i++) {
      if (LAPOK[i][1].test(szov)) {
        BELIV = LAPOK[i][0];
        linkFrissit(nevJelenleg);
        ev('landing_lapok_valaszt', { lapok: BELIV });
        break;
      }
    }
  }, true);

  /* ---------- egyedi modul: jegyválasztó (L16) ---------- */
  var jegyGombok = [].slice.call(document.querySelectorAll('[data-bl-jegy]'));
  var jegyKi = document.querySelector('[data-bl-jegy-ki]');
  function jegyBeallit(j, felhasznalo) {
    JEGY = j;
    var g = null;
    jegyGombok.forEach(function (b) {
      var be = b.getAttribute('data-bl-jegy') === j;
      b.setAttribute('aria-pressed', be ? 'true' : 'false');
      if (be) g = b;
    });
    if (jegyKi) {
      jegyKi.textContent = '';
      if (g) {
        var kiemel = document.createElement('b');
        kiemel.textContent = g.querySelector('.bl-jegy__n').textContent;
        jegyKi.appendChild(document.createTextNode('A jegyed: '));
        jegyKi.appendChild(kiemel);
        jegyKi.appendChild(document.createTextNode('. A gombok már ezzel nyitják meg a naplót.'));
      } else {
        jegyKi.textContent = jegyKi.getAttribute('data-bl-alap') || '';
      }
    }
    linkFrissit(nevJelenleg);
    try { if (j) sessionStorage.setItem('bl-jegy', j); else sessionStorage.removeItem('bl-jegy'); } catch (e) {}
    try {
      var cim = new URL(location.href);
      if (j) cim.searchParams.set('jegy', j); else cim.searchParams.delete('jegy');
      history.replaceState(null, '', cim.pathname + cim.search + cim.hash);
    } catch (e) {}
    if (felhasznalo) ev('landing_jegy_valaszt', { jegy: j });
  }
  if (jegyGombok.length) {
    jegyGombok.forEach(function (b) {
      b.addEventListener('click', function () {
        var j = b.getAttribute('data-bl-jegy');
        jegyBeallit(JEGY === j ? '' : j, true);   /* ugyanarra újra koppintva törlődik */
      });
    });
    var j0 = '';
    try { j0 = sessionStorage.getItem('bl-jegy') || ''; } catch (e) {}
    try { j0 = new URLSearchParams(location.search).get('jegy') || j0; } catch (e) {}
    if (j0 && jegyGombok.some(function (b) { return b.getAttribute('data-bl-jegy') === j0; })) jegyBeallit(j0, false);
  }

  /* ---------- a név mező ---------- */
  var mezo = document.querySelector('[data-bl-nev]');
  var kuldve = false;
  var idozito = null;
  function valtozas(felhasznalo) {
    var n = tisztit(mezo.value);
    if (n !== mezo.value) mezo.value = n;
    var tiszta = n.trim();
    nevJelenleg = tiszta;
    rajzol(n);
    linkFrissit(tiszta);
    try { sessionStorage.setItem(KULCS, tiszta); } catch (e) {}
    clearTimeout(idozito);
    if (felhasznalo && tiszta && !kuldve) idozito = setTimeout(function () { kuldve = true; ev('landing_name_typed'); }, 700);
  }
  if (mezo) {
    mezo.addEventListener('input', function () { valtozas(true); });
    var kezdo = '';
    try { kezdo = sessionStorage.getItem(KULCS) || ''; } catch (e) {}
    try { kezdo = new URLSearchParams(location.search).get('nev') || kezdo; } catch (e) {}
    if (kezdo) mezo.value = tisztit(kezdo);
    valtozas(false);
  } else {
    rajzol('');
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { rajzol(mezo ? tisztit(mezo.value) : ''); });
  }

  /* ---------- telefon: a cím és a rács címe egy sorba, a borító a lehető legnagyobb, de a gombig még elférjen ---------- */
  var egyCim = [].slice.call(document.querySelectorAll('.bl-hero h1, .bl-rcim h2, .lapozo-cim'));
  var heroKep = document.querySelector('.bl-hero__c');
  var heroGomb = document.querySelector('.bl-hero__cta');
  function egySor(el, also) {
    el.style.removeProperty('font-size');
    el.style.removeProperty('white-space');
    if (innerWidth >= 700) return;
    var alap = parseFloat(getComputedStyle(el).fontSize);
    el.style.setProperty('white-space', 'nowrap', 'important');
    var r = document.createRange();
    r.selectNodeContents(el);
    var w = r.getBoundingClientRect().width;
    var tér = el.clientWidth;
    if (w > tér && tér > 0) {
      var m = alap * tér / w * 0.99;
      if (m >= alap * also) el.style.setProperty('font-size', m.toFixed(2) + 'px', 'important');
      else el.style.removeProperty('white-space');
    }
  }
  function kepMeret() {
    if (!heroKep || !heroGomb) return;
    heroKep.style.removeProperty('--bl-f');
    if (innerWidth >= 700) return;
    /* f = minden, ami a borító KÉPE fölött és alatta van a gomb aljáig (a kép négyzet, magassága = szélessége) + 10 px levegő a gomb alatt */
    var f = heroGomb.getBoundingClientRect().bottom + (window.pageYOffset || 0) - heroKep.getBoundingClientRect().width + 10;
    heroKep.style.setProperty('--bl-f', Math.round(f) + 'px');
  }
  function meretez() {
    egyCim.forEach(function (el) { egySor(el, el.tagName === 'H1' ? 0.8 : 0.75); });
    kepMeret();
  }
  var utolsoSz = innerWidth;
  window.addEventListener('resize', function () {
    if (innerWidth !== utolsoSz) { utolsoSz = innerWidth; meretez(); }
  });
  window.addEventListener('orientationchange', function () { setTimeout(meretez, 200); });
  meretez();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(meretez);
  /* ---------- ragadós sáv: csak akkor, ha a hero gombja már FELJEBB gördült a képernyőnél ---------- */
  var savEl = document.querySelector('[data-bl-sticky]');
  var cta = document.querySelector('.bl-hero__cta');
  if (savEl && cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (b) {
      var r = b[0].boundingClientRect;
      savEl.classList.toggle('is-on', !b[0].isIntersecting && r.bottom < 0);
    }).observe(cta);
  }

  /* ---------- kattintások ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var lap = t.closest('[data-bl-lb]');
    if (lap) {
      e.preventDefault();
      lbNyit(lap);
      return;
    }
    var a = t.closest('[data-bl-ev]');
    if (a) { ev(a.getAttribute('data-bl-ev'), { termek: (diak[aktiv] && diak[aktiv].getAttribute('data-bl-termek')) || '' }); return; }
    if (t.closest('.product-grid a[href*="/products/"], results-list a[href*="/products/"]')) ev('landing_card_click');
  }, true);
})();
